import api from '@/api'
import lodash from 'lodash'

const controller = {
  createOne: (key) => ({
    entity: 'blob',
    data: '',
    key
  })
}

export default {
  namespaced: true,
  state: {
  },
  actions: {
    async load (context, key) {
      const res = await api.postBIZ('/api/content/find', {selector: {entity: 'blob', key: key}, limit: 1})
      return res.data[0]
    },
    async validate (context, key) {
      var result = await context.dispatch('load', key)
      if (!result) {
        await api.putBIZ('/api/content', [{content: lodash.extend(controller.createOne(key), {author: context.rootState.user.data._id})}])
        result = await context.dispatch('load', key)
      }
      return result
    },
    async update (context, blob) {
      const res = await api.putBIZ('/api/content', {uri: blob._id, content: lodash.extend(blob, {entity: 'blob', author: context.rootState.user.data._id})})
      blob._rev = res.data[0].rev
      return blob
    },
    async findAndUpdate (context, blob) {
      const res = await api.postBIZ('/api/content/find', {selector: {_id: blob._id}, fields: ['_rev']})
      if (res.data.length > 0) {
        blob._rev = res.data.shift()._rev
      }
      const result = await context.dispatch('update', blob)
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/blobs.js